function handleMonthStatement (obj) {
  let list = [
    {sysnm: '线上充值收入', sysamt: obj.syscharamt, banknm: '对账单', bankamt: obj.bankamt},
    {sysnm: '外部码扫码收入', sysamt: obj.syswxcodeamt, banknm: '', bankamt: ''},
    {sysnm: '线上管理费收入', sysamt: obj.sysmanageamt, banknm: '', bankamt: ''},
    {sysnm: '销户线上结清', sysamt: obj.sysacctcancelamt, banknm: '', bankamt: ''},
    {sysnm: '收入合计', sysamt: obj.sysincometotalamt, banknm: '收入合计', bankamt: obj.bankincomeamt},
    {sysnm: '现金收入', sysamt: obj.syscashamt, banknm: '现金存入', bankamt: obj.bankcashamt},
    {sysnm: '总计', sysamt: obj.systotalamt, banknm: '总计', bankamt: obj.banktotalamt}
  ]
  return list
}

export {handleMonthStatement}



// WEBPACK FOOTER //
// ./src/util/handleReport.js